"use client";

import Link from "next/link";
import { forwardRef, type MouseEvent } from "react";
import { pushDataLayerEvent } from "@/lib/gtm/data-layer";

type TrackedExtras = {
	event: string;
	eventParams?: Record<string, unknown>;
};

type TrackedAnchorProps = Omit<React.ComponentPropsWithoutRef<"a">, "href"> &
	TrackedExtras & { href: string };

export const TrackedAnchor = forwardRef<HTMLAnchorElement, TrackedAnchorProps>(
	function TrackedAnchor({ event, eventParams, onClick, ...rest }, ref) {
		const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
			pushDataLayerEvent({ event, ...eventParams });
			onClick?.(e);
		};
		// biome-ignore lint/a11y/noStaticElementInteractions: rest spread always includes href
		// biome-ignore lint/a11y/useValidAnchor: rest spread always includes href
		return <a ref={ref} {...rest} onClick={handleClick} />;
	},
);

type TrackedLinkProps = React.ComponentProps<typeof Link> & TrackedExtras;

export const TrackedLink = forwardRef<HTMLAnchorElement, TrackedLinkProps>(
	function TrackedLink({ event, eventParams, onClick, ...rest }, ref) {
		const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
			pushDataLayerEvent({ event, ...eventParams });
			onClick?.(e);
		};
		return <Link ref={ref} {...rest} onClick={handleClick} />;
	},
);
